import { DisplayExport, proposeWorkItemCancel, proposeWorkItemContinueForm, proposeWorkItemViewForm, Todo, WorkItemAction } from "@fusion-advantage/formlib"
import { useAppSelector } from "../../../redux/hooks"
import { V2L3TodoReadyDetail } from "@fusion-advantage/formrender"
import { selectDashboardDisplayIdentity } from "../../../redux/dashboardDataSlice"

interface LxTodoReadyDetailProps {
	todo: Todo
	displayExp: DisplayExport
	pendingSync: boolean
	onActionClick: (action: WorkItemAction) => void
}

export const LxTodoReadyDetail = ({todo, displayExp, pendingSync, onActionClick}: LxTodoReadyDetailProps) => {
	const filterByDate = useAppSelector(state => state.dashboardData.filterByDate)
	const user = useAppSelector(selectDashboardDisplayIdentity)
	return (
		<V2L3TodoReadyDetail
			todo={todo}
			dexp={displayExp}
			pendingSync={pendingSync}
			canViewForm={proposeWorkItemViewForm(todo, filterByDate).isOk()}
			canContinueForm={proposeWorkItemContinueForm(todo, displayExp, filterByDate, user).isOk()}
			canCancel={proposeWorkItemCancel(todo, displayExp, filterByDate).isOk()}
			onActionClick={onActionClick}
		/>
	)
}
